
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Carousel, Slide } from "vue-carousel";

@Component({
	components: {
		Carousel,
		Slide,
	},
})
export default class GiftListSlider extends Vue {
	@Prop() private giftList: string[];

	lang: string = "de";
	prevLabel: string = "";
	nextLabel: string = "";

	created() {
		this.lang = this.$root.$data.lang;
		const arrowIcon = this.$root.$data.getIconPath("chevron-right");
		this.prevLabel =
			'<svg fill="#666" class="epoq-svg"><use xlink:href="' +
			arrowIcon +
			'"></use></svg>';
		this.nextLabel =
			'<svg fill="#666" class="epoq-svg"><use xlink:href="' +
			arrowIcon +
			'"></use></svg>';
	}

	mounted() {
		this.$root.$data.triggerClubModal();
	}

	updated() {
		this.$root.$data.triggerClubModal();
	}

	get giftListReverse() {
		return [...this.giftList].reverse();
	}

	get giftListCnt() {
		return this.giftList.length;
	}

	removeFromGiftList(item) {
		this.$bus.$emit("epoqRemoveFromGiftList", item);
	}

	getDiscountState(discountColor) {
		if (discountColor === "purple") {
			return "1";
		}
		if (discountColor === "mint") {
			return "2";
		}
		if (discountColor === "orange") {
			return "3";
		}
		if (discountColor === "yellow") {
			return "4";
		}
		if (discountColor === "magenta") {
			return "5";
		}
		return "2";
	}

	getAvailabilityClass(color) {
		return color === "green" ? "a-hint state-success" : "a-hint state-warning";
	}

	getLoveStateClass(state) {
		return "m-wishlist-actions__prioritize prio-" + state;
	}

	getCommentClass(state) {
		return (
			"m-wishlist-actions__comment" +
			(state ? " m-wishlist-actions__comment--added" : "")
		);
	}

	hasOldPrice(item) {
		const price = parseFloat(item.price);
		const oldPrice = parseFloat(item.oldprice);

		return oldPrice && oldPrice > price;
	}

	getFormattedPrice(price) {
		return parseFloat(price).toFixed(2);
	}

	getItemClubModalUrl(clubDiscount) {
		// arguments: elementClass, language, clubModalType, standardDiscountType, standardDiscountValue, vodBuyDiscountType, vodBuyDiscountValue, vodRentDiscountType, vodRentDiscountValue
		let modalUrl = "/" + this.lang + "/club-info/?";
		let item = {
			// clubModalType: clubDiscount.DiscountType, // 0 = Reduction, 1 = Discount = ['0', '1'],
			clubModalType: "standard",
			standardDiscountType:
				clubDiscount.DiscountType === 0 ? "Reduction" : "Discount",
			standardDiscountValue:
				clubDiscount.DiscountType === 0
					? clubDiscount.Reduction
					: clubDiscount.Percentage,
			vodBuyDiscountType: "",
			vodBuyDiscountValue: "",
			vodRentDiscountType: "",
			vodRentDiscountValue: "",
		};

		if (item.clubModalType == "standard") {
			modalUrl +=
				"mt=" +
				item.clubModalType +
				"&sdt=" +
				item.standardDiscountType +
				"&sdv=" +
				item.standardDiscountValue;
		} else if (item.clubModalType == "vodBuy") {
			modalUrl +=
				"mt=" +
				item.clubModalType +
				"&vbdt=" +
				item.vodBuyDiscountType +
				"&vbdv=" +
				item.vodBuyDiscountValue;
		} else if (item.clubModalType == "vodRent") {
			modalUrl +=
				"mt=" +
				item.clubModalType +
				"&vrdt=" +
				item.vodRentDiscountType +
				"&vrdv=" +
				item.vodRentDiscountValue;
		} else if (item.clubModalType == "vodBuyAndRent") {
			modalUrl +=
				"mt=" +
				item.clubModalType +
				"&vbdt=" +
				item.vodBuyDiscountType +
				"&vbdv=" +
				item.vodBuyDiscountValue;
			modalUrl +=
				"&vrdt=" +
				item.vodRentDiscountType +
				"&vrdv=" +
				item.vodRentDiscountValue;
		} else {
			modalUrl += "mt=unknown";
		}

		return modalUrl;
	}

	handleCustomProductClickEvent(item) {
		this.sendCustomProductClickEvent(item);
		// window.document.location = item.link;
		this.$root.$data.navigateToUrl(item.link);
	}

	sendCustomProductClickEvent(item) {
		window.dataLayer.push({
			event: "shopEvent",
			eventCategory: "Geschenkefinder",
			eventAction: "Zum Produkt",
			eventLabel:
				"" +
				(item.productId || "__NOT_SET__") +
				"_|_" +
				(item.title || "__NOT_SET__") +
				"",
		});
	}

	itemAddToCart(item) {
		// window.basketItemAdd(item.productId, 1, false);
		this.$root.$data.addToCart(item);
		this.sendCustomAddToCartEvent(item);
		console.log("Item added to cart -> " + item.productId);
	}

	sendCustomAddToCartEvent(item) {
		window.dataLayer.push({
			event: "shopEvent",
			eventCategory: "Geschenkefinder",
			eventAction: "Artikel in Warenkorb",
			eventLabel:
				"" +
				(item.productId || "__NOT_SET__") +
				"_|_" +
				(item.title || "__NOT_SET__") +
				"",
		});
	}

	showClubModal(clubDiscount) {
		this.$bus.$emit("epoqShowClubModal", clubDiscount);
	}
}
